import { createRouter, createWebHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'

/** 路由元信息类型：新增页面需要新增 meta 字段时在此声明 */
declare module 'vue-router' {
  interface RouteMeta {
    /** 文档标题（写入 document.title） */
    title?: string
    /** 是否缓存页面实例（配合 KeepAlive 使用，当前未启用） */
    keepAlive?: boolean
  }
}

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'PickupVoucher',
    component: () => import('@/views/PickupVoucher.vue'),
    meta: {
      title: '提油凭证',
      keepAlive: true
    }
  },
  {
    // 短信入口 https://jdh5.klybt.com/{ticket} 命中此路由
    path: '/:ticket',
    name: 'PickupVoucherTicket',
    component: () => import('@/views/PickupVoucher.vue'),
    meta: {
      title: '提油凭证',
      keepAlive: true
    }
  }
  // 后续可扩展：
  // { path: '/history', name: 'PickupHistory', component: () => import('@/views/PickupHistory.vue') },
  // { path: '/profile', name: 'DriverProfile', component: () => import('@/views/DriverProfile.vue') },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

router.beforeEach((to) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
})

export default router
